module.exports = __webpack_public_path__ + "img/Modernisme_Tanker_i_tida10.119e01cf.jpg";